'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _resources = require('redux/modules/resources');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module2Extra1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}, { changeResource: _resources.changeResource }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Extra1, _Component);

  function Module2Extra1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Extra1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Extra1.__proto__ || (0, _getPrototypeOf2.default)(Module2Extra1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Challenges of introducing change into the home',
      types: {
        app: 0,
        extra: 1,
        activity: 2
      }
    }, _this.handleOnClick = function (module, item, page, event) {
      console.log(event);
      _this.props.changeResource(module, item, page);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // used to navigate to a resource item


  (0, _createClass3.default)(Module2Extra1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'If you do decide to try out something different, some members of the family might not be very happy about it, which can be hard to manage.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Change can be difficult for everyone, and we know that when a change is introduced, kids like to test the boundaries. This is a very common experience for parents and carers.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Being consistent can be a challenge, but it should make the change process smoother if there is consistency.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/resourceslanding', onClick: this.handleOnClick.bind(this, 2, 2, 0) },
                  '"Establishing rules"'
                ),
                ' and ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/resourceslanding', onClick: this.handleOnClick.bind(this, 2, 3, 0) },
                  '"Dealing with change"'
                ),
                ' contains some ideas around coping with change and establishing rules.'
              )
            )
          )
        )
      );
    }
  }]);
  return Module2Extra1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  changeResource: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module2Extra1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Extra/Extra1.js
// module id = 1193
// module chunks = 0